var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": 'Our Partners'
    }
  })], 1)], 1), _vm._m(0)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-12 py-4"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('span', [_vm._v("Our Partners")]), _c('h2', [_vm._v("Strategic Partnership to Improve Your Organization's Cyber-Readiness Posture")])]), _c('div', {
    staticClass: "mt-4 text-lg-left"
  }, [_c('p', [_vm._v(" The Project Spectrum Team prides itself on developing strategic partnerships to raise the level of products and services we can provide you. Prominent among our current strategic partnerships are our formal relationships with the DoD’s Cybersecurity Maturity Model Compliance (CMMC) Program, the Manufacturing Extension Program (MEP), the Mentor-Protégé Program (MPP), and the Small Business Administration (SBA). We urge you to explore and learn more about each of these partners and programs to find out how your participation could improve your organization’s readiness posture. "), _c('br'), _c('br'), _vm._v(" As always, if you have any questions, our cyber advisors are here to help! Contact us at "), _c('a', {
    attrs: {
      "href": "mailto:outreach@projectspectrum.io"
    }
  }, [_vm._v(" outreach@projectspectrum.io ")]), _vm._v(". ")])])]), _c('hr', {
    staticClass: "col-sm-12"
  }), _c('div', {
    staticClass: "col-12 py-2"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h2', [_vm._v("OSBP")])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('blockquote', {
    staticClass: "blockquote"
  }, [_c('p', [_vm._v("The DoD Office of Small Business Programs (OSBP) initiated Project Spectrum as a comprehensive platform to provide the tools and training needed to increase cybersecurity awareness and maintain compliance in accordance with DoD contracting requirements. ")])]), _c('p', {
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_vm._v("► "), _c('a', {
    attrs: {
      "href": "https://business.defense.gov/Programs/Cyber-Security-Resources/"
    }
  }, [_c('strong', [_vm._v(" LEARN MORE ")])])])]), _c('div', {
    staticClass: "col-4"
  }, [_c('img', {
    staticClass: "img-fluid w-50",
    staticStyle: {
      "padding": "0px 30px 0px 0px"
    },
    attrs: {
      "src": "assets/images/OSBP.png",
      "alt": ""
    }
  })])])]), _c('hr', {
    staticClass: "col-sm-12"
  }), _c('div', {
    staticClass: "col-12 py-2"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h2', [_vm._v("CMMC")])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('blockquote', {
    staticClass: "blockquote"
  }, [_c('p', [_vm._v("The Cybersecurity Maturity Model Certification (CMMC) is a unified standard for implementing cybersecurity across the Defense Industrial Base (DIB), which includes over 300,000 companies in the supply chain. ")])]), _c('p', {
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_vm._v("► "), _c('a', {
    attrs: {
      "href": "/#/about-cmmc"
    }
  }, [_c('strong', [_vm._v(" LEARN MORE ")])])])]), _c('div', {
    staticClass: "col-4"
  }, [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": "assets/images/CMMC.png",
      "alt": ""
    }
  })])])]), _c('hr', {
    staticClass: "col-sm-12"
  }), _c('div', {
    staticClass: "col-12 py-4"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h2', [_vm._v("MEP")])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('blockquote', {
    staticClass: "blockquote"
  }, [_c('p', [_vm._v(" Project Spectrum and the Manufacturing Extension Partnership (MEP) are working together to provide manufacturers with access to a self-directed platform for cutting edge cybersecurity compliance training and tools. ")])]), _c('p', {
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_vm._v("► "), _c('a', {
    attrs: {
      "href": "/#/mep"
    }
  }, [_c('strong', [_vm._v(" LEARN MORE ")])])])]), _c('div', {
    staticClass: "col-4"
  }, [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": "assets/images/MEP.png",
      "alt": ""
    }
  })])])]), _c('hr', {
    staticClass: "col-sm-12"
  }), _c('div', {
    staticClass: "col-12 py-4"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h2', [_vm._v("SBA")])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('blockquote', {
    staticClass: "blockquote"
  }, [_c('p', [_vm._v(" If you want to do business with any Federal Government agency, you need to know that your company’s systems and data are secure. Specifically, you need to demonstrate the ability to safeguard Federal Contract Information (FCI) and Controlled Unclassified Information (CUI) in order to secure a government contract. ")])]), _c('p', {
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_vm._v("► "), _c('a', {
    attrs: {
      "href": "/#/small-business-administration"
    }
  }, [_c('strong', [_vm._v(" LEARN MORE ")])])])]), _c('div', {
    staticClass: "col-4"
  }, [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": "assets/images/SBA.png",
      "alt": ""
    }
  })])])]), _c('hr', {
    staticClass: "col-sm-12"
  }), _c('div', {
    staticClass: "col-12 py-4"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h2', [_vm._v("MPP Pilot")])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('blockquote', {
    staticClass: "blockquote"
  }, [_c('p', [_vm._v("Project Spectrum’s Cybersecurity for Defense Industrial Base Mentor-Protégé Program (MPP) Pilot helps eligible small businesses improve cybersecurity compliance and cyber incident reporting and hygiene. ")])]), _c('p', {
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_vm._v("► "), _c('a', {
    attrs: {
      "href": "/#/pilot-program"
    }
  }, [_c('strong', [_vm._v(" LEARN MORE ")])])])]), _c('div', {
    staticClass: "col-4"
  }, [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": "assets/images/MPP.png",
      "alt": ""
    }
  })])])]), _c('hr', {
    staticClass: "col-sm-12"
  })])])]);

}]

export { render, staticRenderFns }